import { getLang } from '@shared/i18n';
import { CONTACT_EMAIL, PUBLISHER } from '../config';

export default function Legal() {
  if (getLang() === 'en') {
    return (
      <div className="container narrow legal" style={{ paddingTop: 40 }}>
        <h1>Legal notice</h1>
        <h2>Publisher</h2>
        <p>
          The FollowMe app and this website are published by {PUBLISHER}.
          <br />
          Contact: <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        </p>
        <h2>Hosting</h2>
        <p>
          Website: Cloudflare, Inc. — San Francisco, United States — cloudflare.com
          <br />
          App data: Supabase, Inc. — supabase.com
        </p>
        <h2>Intellectual property</h2>
        <p>
          The FollowMe name, the FM logo, the texts and the app are the property of their publisher. Website map tiles:
          © OpenStreetMap contributors.
        </p>
      </div>
    );
  }
  return (
    <div className="container narrow legal" style={{ paddingTop: 40 }}>
      <h1>Mentions légales</h1>
      <h2>Éditeur</h2>
      <p>
        L'application FollowMe et ce site sont édités par {PUBLISHER}.
        <br />
        Contact : <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
      </p>
      <h2>Hébergement</h2>
      <p>
        Site web : Cloudflare, Inc. — San Francisco, États-Unis — cloudflare.com
        <br />
        Données de l'application : Supabase, Inc. — supabase.com
      </p>
      <h2>Propriété intellectuelle</h2>
      <p>
        Le nom FollowMe, le logo FM, les textes et l'application sont la propriété de leur éditeur. Fonds de carte du
        site : © les contributeurs d'OpenStreetMap.
      </p>
    </div>
  );
}
